import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    border-bottom: 1px solid ${ThemeColors.getGreenColor(0.4)};
    padding: 0.2rem;
`
